var map = {
	"./aboutme.png": 1677,
	"./bilibili.png": 72350,
	"./blogger.png": 97214,
	"./douyin.png": 26458,
	"./facebook.png": 24642,
	"./flickr.png": 56283,
	"./foursquare.png": 22847,
	"./github.png": 65639,
	"./gravatar.png": 11134,
	"./instagram.png": 73576,
	"./linkedin.png": 98964,
	"./online.png": 38419,
	"./other.png": 74866,
	"./pinterest.png": 60498,
	"./print.png": 71417,
	"./reddit.png": 71490,
	"./soundcloud.png": 90298,
	"./stackexchange.png": 78255,
	"./stackoverflow.png": 20814,
	"./steam.png": 98868,
	"./tiktok.png": 18800,
	"./tumblr.png": 25004,
	"./twitter.png": 2709,
	"./wechat_public.png": 65114,
	"./weibo.png": 40212,
	"./xiaohongshu.png": 12111,
	"./yahoo.png": 99912,
	"./youtube.png": 19743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16141;